var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.758 4.903v-.689c-6.24.487-11.154 5.706-11.154 12.073 0 6.687 5.422 12.109 12.11 12.109.347 0 .69-.015 1.03-.044v-4.456a7.68 7.68 0 0 0 3.885-13.508l-1.27 1.29.015.012-1.598 1.598-1.07 1.089v-.019l-5.59 5.59a5.883 5.883 0 0 1 5.606-9.426l.02-5.351v-.03c5.699.522 10.162 5.313 10.162 11.147 0 5.49-3.953 10.056-9.168 11.01v2.555a13.82 13.82 0 0 1-2.025.148C10.14 30 4 23.86 4 16.287 4 9.034 9.63 3.097 16.758 2.606V2l2.522 1.375-2.522 1.528zM6.521 16.287c.001-6.041 4.787-10.964 10.773-11.185V8.62a7.678 7.678 0 0 0-4.301 13.722l4.34-4.413v.073l5.16-5.162a5.883 5.883 0 0 1-5.179 9.35l-.02 4.945v.336c-5.986-.22-10.772-5.143-10.772-11.183z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnl);
export default __webpack_public_path__ + "static/media/SNL.11a0f1caf50d67aa203009faad80e733.svg";
export { ForwardRef as ReactComponent };